// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KJVV","top":"styles_top__1e4LO"};